var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status==='loading')?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":20,"width":2}}):(_vm.status==='offline')?_c('i',[_vm._v("Not available in offline mode.")]):(_vm.status==='loaded')?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }